// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container__10X8T","mediaContainer":"style__mediaContainer__1HtqN","loading":"style__loading__uOBKk","wrapper":"style__wrapper__J9s6T","storyContainer":"style__storyContainer__1kOS4","detailsContainer":"style__detailsContainer__24Kni","close":"style__close__1Vt_l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account_page/story_details/style.scss
// module id = 352
// module chunks = 0